import store from '../store';
import * as moment from 'moment';
import * as syncConst from '@/const/sync';
import { round } from 'lodash';
import lockr from 'lockr';
import * as http from '@/utils/http';

export function filterVisible(name) { // 过滤是否显示自定义搜索数据
  return store.state.filterFiles.indexOf(name) > -1;
}

export function getConfig(http, route) {
  let { c, a } = route.meta;
  const data = {
    _controller: c,
    _action: a,
    ...route.params,
  };
  return http._post({ url: '/index/api_base/getConfig', data }).then(({ menu, data }) => {
    store.commit('updateMenu', menu); // 菜单信息
    store.commit('setUserInfo', data); // 当前登陆用户信息
    store.commit('updateMessageAmount', data.notifition_amount); // 推送，通知消息个数信息
    data.bubbleCount && store.commit('setBubbleCount', data.bubbleCount); // 推送，未读重复资源录入数量
    return Promise.resolve({ menu, userInfo: data });
  });
}

/**
 * 格式化教师信息, 渠道来源 用于根据首字母分组
 *
 * @author Cong Peijun <congpeijun@jiemo.net>
 * @param  {Array} teacher
 * @return {Array}
 */
export function formatSelectGroupData(teacher = []) {
  let temp = {};
  if (typeof teacher.length !== 'number') {
    return temp;
  }
  teacher.forEach((value) => {
    if (!temp[value.first_char]) {
      temp[value.first_char] = [];
    }
    temp[value.first_char].push(value);
  });
  return temp;
}

export function delay(time = 0) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, time * 1000);
  });
}

export function isEmpty(target) {
  if (Array.isArray(target) && target.length === 0) {
    return true;
  }
  if (typeof target === 'undefined') {
    return true;
  }
  return target === '' || target === null || target === undefined || JSON.stringify(target) === '{}';
}

export function getCustomYear(year) {
  if (!year) {
    return null;
  }
  return moment()
    .set({ year: year, month: 1, date: 15 })
    .format('YYYY-MM-DD');
}

export function getCustomMonth(month) {
  if (!month) {
    return null;
  }
  return moment()
    .set({ month: month - 1, date: 15 })
    .format('YYYY-MM-DD');
}

export function formatCustomYear(year) {
  if (!year) {
    return null;
  }
  return moment(year).format('YYYY');
}

export function formatCustomMonth(month) {
  if (!month) {
    return null;
  }
  return moment(month).format('MM');
}

export function deepClone(obj) {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * 根据同步类型获取同步的标签
 *
 * @param {Number} syncType
 */
export function getSiteTagByType(syncType) {
  switch (syncType) {
    case syncConst.FIB_TO_JOB:
    case syncConst.TRAINING_TO_JOB:
      return '求职';
    case syncConst.JOB_TO_FIB:
    case syncConst.TRAINING_TO_FIB:
      return '蓝火';
    case syncConst.JOB_TO_TRAINING:
    case syncConst.FIB_TO_TRAINING:
      return '考培';
    case syncConst.FIB_TO_FIB:
      return '留学';
    default:
      return '';
  }
}

/**
 * 并区分出终端类型
 * @param String ua
 * @return
 *  - wework 企业微信
 *  - wechat 微信
 *  - dingtalk 钉钉
 *  - other 其他
 */
export function getPlatformSource() {
  const ua = navigator.userAgent;
  const isWx = ua.match(/MicroMessenger/i);
  let source = '';
  if (isWx && !!isWx.length) {
    if (ua.includes('wxwork')) {
      source = 'wework';
    } else {
      source = 'wechat';
    }
  } else if (ua.includes('DingTalk')) {
    source = 'dingtalk';
  } else {
    source = 'other';
  }
  return source;
}

export function isPhone() {
  const ua = navigator.userAgent;
  const isPhone = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
  if (!(ua.match(isPhone) && ua.match(isPhone).length)) {
    return false;
  }
  return true;
}

/**
 * 将数值四舍五入(保留2位小数)后格式化成金额形式
 *
 * @param price 数值(Number或者String)
 * @return 金额格式的字符串,如'$1,234,567.45'
 * @type String
 */
export function formatCurrency(price) {
  price = round(price, 2).toString();
  if (price === 'NaN') {
    return '0.00';
  }
  return price.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

/**
 * 判断是否为图片类型地址
 */
export function checkImageUrl(url) {
  const fileName = url.split('?')[0];
  const splitArr = fileName.split('.');
  let suffix = splitArr[splitArr.length - 1];

  if (suffix !== '') {
    // 判断图片格式
    return ['png', 'jpg', 'jpeg', 'bmp', 'gif'].indexOf(suffix.toLocaleLowerCase()) >= 0;
  }
  return false;
}

/**
 * 获取渠道数据
 */
export function getChannelDataset() {
  const cacheKey = 'channels';
  const channels = lockr.get(cacheKey);
  if (channels) {
    return Promise.resolve(channels);
  }

  return new Promise((resolve) => {
    http._get({
      url: '/index/api_base/getChannel',
    }).then(({ data }) => {
      lockr.set(cacheKey, data);
      return resolve(data);
    });
  });
}

export function getGlobalSearchData() {
  const cacheKey = 'global_search_ds';
  const dataset = lockr.get(cacheKey);
  if (dataset) {
    return Promise.resolve(dataset);
  }

  return new Promise((resolve) => {
    http._get({
      url: '/index/Student/searchDs',
    }).then(({ data }) => {
      lockr.set(cacheKey, data);
      resolve(data);
    });
  });
}

export default {
  filterVisible,
  getConfig,
  formatCurrency,
  checkImageUrl,
  formatSelectGroupData,
  getPlatformSource,
  delay,
  isEmpty,
  deepClone,
  getChannelDataset,
  getGlobalSearchData,
};
